const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case "UPDATE_INPUTS_CONFIG":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
